module.exports = __webpack_public_path__ + "static/media/steinsand.3e14a878.svg";